










































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";
import KyodaiChargeKey from "@/components/kyodai-charge-key";

import _ from "lodash";
import { isNullOrEmpty } from "@/methods/validation";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const kyodaiChargeStore = inject(KyodaiChargeKey);
    if (!kyodaiChargeStore) {
      throw new Error(`${KyodaiChargeKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const loadedFlag = ref<boolean>(false);
    const accessToken = computed(() => globalStore.auth.token);

    const member = computed(() => memberStore.member);

    // 暫定のデータ取得(本来はDBから取得する)
    const kyodaiAccountHistoryList = ref<any>([]);

    // 3年分のボタンを表示
    const currentYear = new Date().getFullYear();
    const yearList = _.range(currentYear, currentYear - 3, -1);
    const selectYear = ref(currentYear);

    const slideIndex = ref<number>(0);

    // テーブル
    const kyodaiAccountHistoryHeaders = [
      // hide-default-headerが効いていると、widthを指定しても無効となる
      { text: "日時", value: "created_at", align: "center" },
      { text: "ステータス", value: "status", align: "center" },
      { text: "KYODAI 会員ナンバー（6桁）", value: "kyodai_account_number", align: "center" }
    ];

    onMounted(async () => {
      loadedFlag.value = true;
      memberStore.setAuthorizationHeader(accessToken.value);
      await memberStore.getMember();
      await kyodaiChargeStore.getKyodaiAccount(member.value.member_no);
      await kyodaiChargeStore.getKyodaiAccountHistoryList(
        String(Math.floor(member.value.member_no))
      );
      kyodaiAccountHistoryList.value = kyodaiChargeStore.kyodaiAccountHistoryList;
      if (!isNullOrEmpty(kyodaiChargeStore.selectedYear)) {
        selectYear.value = kyodaiChargeStore.selectedYear;
      }
      loadedFlag.value = false;
    });

    return {
      loadedFlag,
      member,
      kyodaiAccountHistoryHeaders,
      kyodaiAccountHistoryList,
      yearList,
      selectYear,
      slideIndex
    };
  },
  components: {}
});
